import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import auth from '../../../../../services/authService';
import ExportXmlModal from '../../../../../components/modals/ExportXmlModal';
import './ExportPlugin.scss';

const ExportPlugin = ({ song }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const user = auth.getCurrentUser();

  if (!user || !user.isAdmin || user.teamId !== song.team._id) return null;

  // Hide Chords strips song.parts for the view only; the export's own Chords option decides
  const exportSong = song.originalParts ? { ...song, parts: song.originalParts } : song;

  return (
    <div className="ExportPlugin song-plugin">
      <span className="plugin__title">{t('view.export')}</span>
      <div className="btn" onClick={() => setShowModal(true)}>
        <span className="plugin__toggle">XML</span>
      </div>
      <ExportXmlModal isOpen={showModal} onClose={() => setShowModal(false)} song={exportSong} />
    </div>
  );
};

ExportPlugin.propTypes = {
  song: PropTypes.object.isRequired,
};

export default ExportPlugin;
